/* HolzBM - мобильный порядок блоков на странице товара.

   <750px:  отзывы + название → ГАЛЕРЕЯ → описание и остальное.

   ЗАГРУЖАЕТСЯ В <head> БЕЗ defer и вешает MutationObserver на документ:
   узлы переставляются в тот момент, когда парсер их создал, до первой
   отрисовки блока. Вариант с defer давал видимый прыжок заголовка. */
(() => {
  'use strict';

  const MQ = window.matchMedia('(max-width: 749px)');
  const WRAP_CLASS = 'hbm-title-top';

  let wrapper = null;
  let moved = [];
  let placeholders = [];
  let media = null;
  let done = false;

  function collect() {
    const grid = document.querySelector('.product-information__grid');
    if (!grid) return false;

    media = grid.querySelector('.product-information__media');
    const content = grid.querySelector('.product-details > .group-block > .group-block-content');
    if (!media || !content) return false;

    const group = content.querySelector(':scope > .group-block');
    if (!group) return false;

    const inner = group.querySelector('.group-block-content') || group;
    const kids = Array.from(inner.children);
    if (kids.length < 2) return false;

    // только плашка отзывов и заголовок; описание остаётся под фото
    moved = kids.slice(0, 2);
    return true;
  }

  function moveUp() {
    if (wrapper || !moved.length) return;
    wrapper = document.createElement('div');
    wrapper.className = WRAP_CLASS;

    moved.forEach((node) => {
      const ph = document.createComment('hbm-ph');
      node.parentNode.insertBefore(ph, node);
      placeholders.push(ph);
      wrapper.appendChild(node);
    });

    media.parentNode.insertBefore(wrapper, media);
  }

  function moveBack() {
    if (!wrapper) return;
    moved.forEach((node, i) => {
      const ph = placeholders[i];
      if (ph && ph.parentNode) {
        ph.parentNode.insertBefore(node, ph);
        ph.remove();
      }
    });
    placeholders = [];
    wrapper.remove();
    wrapper = null;
  }

  function apply() {
    if (!moved.length && !collect()) return false;
    if (MQ.matches) moveUp();
    else moveBack();
    return true;
  }

  // ловим узлы как только парсер их создал
  const observer = new MutationObserver(() => {
    if (done) return;
    if (apply()) {
      done = true;
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // страховка
  document.addEventListener('DOMContentLoaded', () => {
    if (!done && apply()) {
      done = true;
      observer.disconnect();
    }
  });

  MQ.addEventListener('change', apply);
})();
